import { ICategory as ProductCategory } from '../../model/category';

export class ProductsApiMapper {
  static toProductCategories(api: any): ProductCategory[] {
    return api.map((c: any) => ({
      id: c.categoryId,
      name: c.categoryName,
      description: c.categoryDescription,
      products: c.products.map((p: any) => ({
        ...p,
        id: p.productId,
      })),
    }));
  }
}
